

export const BEUrl =  'https://svitconnect.onrender.com';